
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import 'air-datepicker/dist/css/datepicker.min.css';
import { VMoney } from 'v-money';

const $ = require('jquery');
const totalData = [
  'total_value_risks',
  'total_sum_secured',
  'retained_sum',
  'facultative_sum',
  'aon_sum',
  'aon_sum_extra',
  'original_tax',
  'original_gross_bonus',
  'original_gross_aon',
  'commission',
  'taxation',
  'netpayment',
  'assignment_percent_aon',
];
window.$ = $;
window.jQuery = $;
require('air-datepicker');

@Component({
  components: {
    Paginator: () => import('@/components/Paginator.vue'),
    SortColumn: () => import('@/components/SortColumn.vue'),
    Modal: () => import('@/components/Modal.vue'),
    InputCurrency: () => import('@/components/InputCurrency.vue'),
    InputText: () => import('@/components/InputText.vue'),
  },
  filters: {
    date(value) {
      return value ? moment(value, 'YYYY-MM-DD').format('LL') : '';
    },
  },
  computed: {
    subscriptorTracks() {
      return (this as any).request.requests_tracks
        ? (this as any).request.requests_tracks.filter(
            (rt: any) => !rt.system && !rt.adminId
          )
        : [];
    },
    aonTracks() {
      return (this as any).request.requests_tracks
        ? (this as any).request.requests_tracks.filter(
            (rt: any) => !rt.system && rt.adminId
          )
        : [];
    },
    systemTracks() {
      return (this as any).request.requests_tracks
        ? (this as any).request.requests_tracks.filter((rt: any) => rt.system)
        : [];
    },
  },
  watch: {
    $route(to, from) {
      (this as any).init();
    },
    rows(value) {
      const _this = this as any;
      if (
        _this.modifyType &&
        (_this.modifyType == 'complex' ||
          _this.modifyType == 'simple' ||
          _this.modifyType == 'anulation')
      ) {
        let dtInterval = setInterval(() => {
          if ($('#assignmentValidityAonFrom').length) {
            (_this as any).$root.localizeDatepicker($);
            $('#assignmentValidityAonFrom').datepicker({
              language: 'es',
              autoClose: true,
              altFormat: 'dd/mm/yyyy',
              dateFormat: 'dd/mm/yyyy',
              onSelect: function onSelect(fd, date) {
                _this.rows.find(
                  (i) => i.id === 'assignmentValidityAonFrom'
                ).value = moment(date).format('DD/MM/YYYY');
                _this.onDatepickerChange();
              },
            });
            clearInterval(dtInterval);
          }
        }, 100);
      }
    },
    modifyType(val) {
      (this as any).generateTable('rows');
    },
  },
  directives: { money: VMoney },
})
export default class RequestsDetails extends Vue {
  dictionary: any = {};
  statuses: any = [];
  title: string = '';
  comment: string = '';
  modalText: string = 'Solicitud de capacidad adicional';
  countries: any = [];
  statusText: string = '';
  request: any = {};
  rows: any = [];
  modifyType: string = '';
  controlZones: any = [];
  isValidForm: boolean = false;
  canCreateEndorsements: boolean = false;
  totalData: any = [
    'total_value_risks',
    'total_sum_secured',
    'retained_sum',
    'facultative_sum',
    'aon_sum',
    'aon_sum_extra',
    'original_tax',
    'original_gross_bonus',
    'original_gross_aon',
    'commission',
    'taxation',
    'netpayment',
    'assignment_percent_aon',
  ];
  endosoCalculationType = '1';
  data: any = {
    money: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: false,
    },
  };

  async init() {
    if (await this.loadRequest()) {
      this.modifyType = this.$route.params.modifyType
        ? this.$route.params.modifyType
        : '';
      this.generateTable('rows');
    } else {
      this.$router.push(`/requests`);
    }
  }

  async mounted() {
    await this.loadControlZones();
    await this.loadDictionary();
    await this.loadStatuses();
    await this.loadCountries();
    await this.init();
    await this.fillInAddress();
    //await this.functionMia();
  }

  fillInAddress() {
    let requests_lat =
      !this.request.requests_details[0].coordinate_lat ||
      this.request.requests_details[0].coordinate_lat == 0
        ? -34.6177
        : parseFloat(this.request.requests_details[0].coordinate_lat);
    let requests_lng =
      !this.request.requests_details[0].coordinate_lng ||
      this.request.requests_details[0].coordinate_lng == 0
        ? -58.3621
        : parseFloat(this.request.requests_details[0].coordinate_lng);

    let markerPosition = {
      location: {
        lat: requests_lat,
        lng: requests_lng,
      },
    };

    if (
      !this.request.requests_details[0].coordinate_lat ||
      this.request.requests_details[0].coordinate_lat == 0
    ) {
      var map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: requests_lat, lng: requests_lng },
        zoom: 3,
      });
    } else {
      var map = new google.maps.Map(document.getElementById('map'), {
        center: { lat: requests_lat, lng: requests_lng },
        zoom: 16,
      });
      var marker = new google.maps.Marker({
        map: map,
        anchorPoint: new google.maps.Point(0, -29),
      });
      marker.setPosition(markerPosition.location);
      marker.setVisible(true);
    }
  }

  formatMoney(val) {
    return String(val).formatMoney();
  }

  exportPDF() {
    (document.querySelector('header.desktop') as any).style.display = 'none';
    (document.querySelector('.footer') as any).style.display = 'none';
    (document.querySelectorAll('.operations') as any).forEach(
      (ii) => (ii.style.display = 'none')
    );
    (document.querySelectorAll('.card-mobile') as any).forEach(
      (ii) => (ii.style.display = 'none')
    );
    (document.querySelectorAll('.cta') as any).forEach(
      (ii) => (ii.style.display = 'none')
    );
    (document.querySelector('.menu-icon') as any).style.display = 'none';
    (document.querySelector('.bell-icon') as any).style.display = 'none';
    window.print();
    document.querySelector('header.desktop').removeAttribute('style');
    document.querySelector('.footer').removeAttribute('style');
    (document.querySelectorAll('.operations') as any).forEach((ii) =>
      ii.removeAttribute('style')
    );
    (document.querySelectorAll('.card-mobile') as any).forEach((ii) =>
      ii.removeAttribute('style')
    );
    (document.querySelectorAll('.cta') as any).forEach((ii) =>
      ii.removeAttribute('style')
    );
    document.querySelector('.menu-icon').removeAttribute('style');
    document.querySelector('.bell-icon').removeAttribute('style');
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get('countries/all');
    this.countries = response.data;
  }

  anulationPartial() {
    this.modifyType = 'anulation';
    this.hideModal(1);
    this.$router.push(`/requests/${this.request.id}/endorsment/anulation`);
  }

  movementEndos() {
    this.$router.push(`/requests/${this.request.id}/endorsment/complex`);
    this.modifyType = 'complex';
    this.hideModal(2);
  }

  noMovement() {
    this.$router.push(`/requests/${this.request.id}/endorsment/simple`);
    this.modifyType = 'simple';
    this.hideModal(2);
  }

  totalValues() {}

  async anulationTotal() {
    const response: any = await (this.$root as any)._post(
      `requests/cancel/${this.request.id}/0`,
      {
        countryId: this.$store.state.user.companies[0].countryId,
      }
    );
    this.$router.push(`/requests/process-requests`);
  }

  async onDatepickerChange() {
    let _this = this;
    _this.isValidForm = true;

    let data = {
      companyId: _this.request.company.id,
      branchId: _this.request.branch.id,
      currencyId: _this.request.currency.id,
    };

    let fieldsToValidate = [
      'validity_from',
      'validity_to',
      'assignmentValidityAonFrom',
      'assignmentValidityAonTo',
    ];

    _this.rows.forEach((row) => {
      if (fieldsToValidate.indexOf(row.name) !== -1) data[row.name] = row.value;
    });
    let response = await (_this.$root as any)._post(
      'requests/validateconditions/',
      data
    );
    if (!response.status) {
      (_this.$root as any).notify(response.error, 'warn');
      _this.isValidForm = false;
      return;
    } else {
      //Dates are valid eval if this evet was triggered by endorsement
      if (_this.modifyType === 'anulation') {
        await _this.calculatePartialEndorsement();
        _this.generateTable('rows');
        return;
      }
      if (_this.modifyType === 'complex') {
        await _this.onInputFieldChange('', false, '');
        return;
      }
    }
  }

  async saveDetailField(field, value) {
    let _this = this;
    if (value != undefined) {
      try {
        const response: any = await (_this.$root as any)._put(
          `requests/updatefield/${_this.request.id}`,
          { field: field, value: value }
        );
        if (response.status) {
          (_this.$root as any).notify('Campo modificado con éxito.');
          _this.rows.find((i) => i.name === field).value = value;
        } else {
          (_this.$root as any).notify(
            'No se pudo modificar el campo.',
            'error'
          );
        }
      } catch (e) {
        (_this.$root as any).notify('No se pudo modificar el campo.', 'error');
      }
    }
  }

  async validateBien(
    field_name: string,
    calculate_tax_first: boolean,
    newValue: any
  ) {
    let validateObject: any = {
      requestId: this.request.id,
      branchId: this.request.branch.id,
      companyId: this.request.company.id,
      currencyId: this.request.currency.id,
      validity_from: '',
      validity_to: '',
      assignmentValidityAonFrom: '',
      assignmentValidityAonTo: '',
      assignment_percent_aon: 0,
      aon_sum: 0,
      aon_sum_extra: 0,
      facultative_sum: 0,
      original_gross_aon: 0,
      original_gross_bonus: 0,
      original_tax: 0,
      retained_sum: 0,
      total_sum_secured: 0,
      total_value_risks: 0,
    };

    this.rows.forEach((row) => {
      if (row.name in validateObject) {
        if (row.name == field_name) {
          validateObject[field_name] = String(newValue).replace(/,/g, '');
        } else {
          validateObject[row.name] =
            row.value == '' ? '0.00' : String(row.value).replace(/,/g, '');
        }
      }
    });
    validateObject.calculate_tax_first = calculate_tax_first ? 1 : 0;
    try {
      const response: any = await (this.$root as any)._post(
        'requests/validateform',
        validateObject
      );
      return response;
    } catch (e) {
      (this.$root as any).notify(e, 'error');
      return false;
    }
  }

  async onInputFieldChange(field_name, calculate_tax_first, newValue) {
    console.log(field_name, calculate_tax_first, newValue);
    let data: any = await (this as any).validateBien(
      field_name,
      calculate_tax_first,
      newValue
    );
    // console.log(data);
    Object.keys(data.data).forEach((key) => {
      this.rows.forEach((row) => {
        if (key == row.name) row.value = data.data[key];
      });
    });
    if (data.error) {
      (this.$root as any).notify(data.error, 'warn');
    }
  }

  //A Partial Endorsement cancels request period in a point in time
  //calculate the proportional return
  async calculatePartialEndorsement() {
    try {
      let _this = this;
      //new value set in partial anulation endorsement

      let new_assignmentValidityAonFrom = moment(
        _this.rows.find((obj) => {
          return obj.name === 'assignmentValidityAonFrom';
        }).value,
        'DD/MM/YYYY'
      );
      //validate if new_assignmentValidityAonFrom is valid
      if (new_assignmentValidityAonFrom.isValid()) {
        //get the original request in db
        let response: any = await (_this.$root as any)._post(
          `requests/one/${_this.$route.params.id}`,
          {
            models: 'companies,branches,subscriptors,currencies',
          }
        );
        let originalRequest = response.data[0];

        //This dates must be converted to moment objet in order to do period calculations
        let original_validity_from = moment(
          originalRequest.validity_from,
          'YYYY-MM-DD'
        );
        let original_validity_to = moment(
          originalRequest.validity_to,
          'YYYY-MM-DD'
        );
        let original_assignmentValidityAonFrom = moment(
          originalRequest.requests_details[0].assignmentValidityAonFrom,
          'YYYY-MM-DD'
        );
        let original_assignmentValidityAonTo = moment(
          originalRequest.requests_details[0].assignmentValidityAonTo,
          'YYYY-MM-DD'
        );

        //differnce should return negative or zero hence will serve to negativize calculations
        let aonPeriodInDays: number = new_assignmentValidityAonFrom.diff(
          original_assignmentValidityAonTo,
          'days'
        );

        let validityPeriondInDays: number = original_validity_to.diff(
          original_validity_from,
          'days'
        );
        //Proportional period 180/360=0.5
        let proportional_period: number =
          aonPeriodInDays / validityPeriondInDays;

        //Form request details
        let requests_details = _this.request.requests_details[0];

        //Stored request details
        let original_request_details = originalRequest.requests_details[0];

        //Recalculate amounts with the cancelled period proportion
        requests_details.aon_sum = String(
          original_request_details.aon_sum * proportional_period
        );

        requests_details.aon_sum_extra = String(
          original_request_details.aon_sum_extra * proportional_period
        );

        requests_details.facultative_sum = String(
          original_request_details.facultative_sum * proportional_period
        );

        requests_details.original_gross_aon = String(
          original_request_details.original_gross_aon * proportional_period
        );

        requests_details.original_gross_bonus = String(
          original_request_details.original_gross_bonus * proportional_period
        );

        requests_details.original_gross_bonus_anual = String(
          original_request_details.original_gross_bonus_anual *
            proportional_period
        );

        requests_details.netpayment = String(
          original_request_details.netpayment * proportional_period
        );

        requests_details.retained_sum = String(
          original_request_details.retained_sum * proportional_period
        );

        requests_details.total_sum_secured = String(
          original_request_details.total_sum_secured * proportional_period
        );

        requests_details.total_value_risks = String(
          original_request_details.total_value_risks * proportional_period
        );

        return;
      } else {
        //date is invalid
        return;
      }
    } catch (e) {
      (this.$root as any).notify(
        'No se pudo actualizar el endoso de anulación parcial.',
        'warn'
      );
    }
  }

  getCountry(id: string) {
    for (let i: number = 0; i < this.countries.length; i++) {
      if (parseInt(this.countries[i].id) === parseInt(id)) {
        return this.countries[i].title;
      }
    }
    return '';
  }

  hideModal(id: number) {
    (this.$refs[`modal${id}`] as any).hide();
  }

  showModal(id: number) {
    (this.$refs[`modal${id}`] as any).show();
  }

  modifyTypeLabel(modType: number) {
    switch (modType) {
      case 0:
        return 'Original';
      case 1:
        return 'Endoso Sin Movimiento de Prima';
      case 2:
        return 'Endoso Con Movimiento de Prima';
      case 3:
        return 'Anulacion Parcial';
      case 4:
        return 'Anulacion Total';
    }
    return 'Original';
  }

  generateTable(key: string) {
    let _this = this;
    let request = this.request;
    this[key] = [];
    //Used to order amount fields among different states
    let order = [
      'total_value_risks',
      'total_sum_secured',
      'retained_sum',
      'facultative_sum',
      'aon_sum',
      'aon_sum_extra',
      'original_tax',
      'original_gross_bonus',
      'original_gross_aon',
      'commission',
      'taxation',
      'netpayment',
      'assignment_percent_aon',
    ];
    //Sort keys array of the request_Details object following criteria
    let keys = Object.keys(request.requests_details[0]);
    keys.sort((a: string, b: string) => {
      const indexA: number = order.indexOf(a);
      const indexB: number = order.indexOf(b);
      return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
    });

    let parent: any = {
      company: {},
      branch: {},
      control_zone: {},
      subscriptor: {},
      currency: {},
      requests_details: [{}],
    };
    if (request.parent_request) {
      parent = request.parent_request;
    }
    /*Common fields*/

    _this[key].push({
      type: 'span',
      label: 'Tipo',
      eValue: request.parent_request
        ? _this.modifyTypeLabel(parent.modifyType)
        : '',
      value: _this.modifyTypeLabel(request.modifyType),
    });

    _this[key].push({
      type: 'span',
      label: 'Empresa',
      eValue: parent.company.name,
      value: request.company.name,
    });
    _this[key].push({
      name: 'policy_number',
      type: _this.modifyType === '' ? 'input' : 'span',
      label: _this.dictionary['policy_number']
        ? _this.dictionary['policy_number'].label
        : 'Número de póliza',
      eValue: parent.requests_details[0].policy_number,
      value: request.requests_details[0].policy_number,
      inputFormattedToMoney: false,
      showFormattedToMoney: false,
      checkchanges: (newValue) => {
        _this.saveDetailField('policy_number', newValue);
      },
    });

    // mariano

    if (
      request.branch.id == 2 ||
      request.branch.id == 3 ||
      request.branch.id == 4 ||
      request.branch.id == 20 ||
      request.branch.id == 21 ||
      request.branch.id == 23
    ) {
      _this[key].push({
        type: 'span',
        label: 'Tipo de vehículo',
        eValue: '',
        value: request.requests_details[0].vehicle_type,
      });

      _this[key].push({
        type: 'span',
        label: 'Marca',
        eValue: '',
        value: request.requests_details[0].brand,
      });

      _this[key].push({
        type: 'span',
        label: 'Modelo',
        eValue: '',
        value: request.requests_details[0].model,
      });

      _this[key].push({
        type: 'span',
        label: 'Año',
        eValue: '',
        value: request.requests_details[0].year,
      });

      _this[key].push({
        type: 'span',
        label: 'Patente',
        eValue: '',
        value: request.requests_details[0].licenseplate,
      });

      _this[key].push({
        type: 'span',
        label: 'Nº certificado',
        eValue: '',
        value: request.requests_details[0].certificate_number,
      });
    }

    _this[key].push({
      type: 'span',
      label: 'País',
      eValue: parent.requests_details[0].country
        ? parent.requests_details[0].country
        : '',
      value: request.requests_details[0].country
        ? request.requests_details[0].country
        : '',
    });
    _this[key].push({
      type: 'span',
      label: 'Ramo',
      eValue: parent.branch.title,
      value: request.branch.title,
    });
    _this[key].push({
      type: 'span',
      label: 'Moneda',
      eValue: parent.currency.description,
      value: request.currency.description,
    });

    _this[key].push({
      id: 'validity_from',
      name: 'validity_from',
      type: 'span',
      label: _this.dictionary.validity_from.label,
      eValue: parent.validity_from
        ? moment(parent.validity_from, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '',
      value: request.validity_from
        ? moment(request.validity_from, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '',
    });
    _this[key].push({
      id: 'validity_to',
      name: 'validity_to',
      type: 'span',
      label: _this.dictionary.validity_to.label,
      eValue: parent.validity_to
        ? moment(parent.validity_to, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '',
      value: request.validity_to
        ? moment(request.validity_to, 'YYYY-MM-DD').format('DD/MM/YYYY')
        : '',
    });
    _this[key].push({
      id: 'assignmentValidityAonFrom',
      name: 'assignmentValidityAonFrom',
      type:
        ['complex', 'simple', 'anulation'].indexOf(_this.modifyType) >= 0
          ? 'datepicker'
          : 'span',
      label: _this.dictionary.assignmentValidityAonFrom.label,
      eValue: parent.requests_details[0].assignmentValidityAonFrom
        ? moment(parent.requests_details[0].assignmentValidityAonFrom, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
        : '',
      value: request.requests_details[0].assignmentValidityAonFrom
        ? moment(request.requests_details[0].assignmentValidityAonFrom, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
        : '',
    });
    _this[key].push({
      id: 'assignmentValidityAonTo',
      name: 'assignmentValidityAonTo',
      type: 'span',
      label: _this.dictionary.assignmentValidityAonTo.label,
      eValue: parent.requests_details[0].assignmentValidityAonTo
        ? moment(parent.requests_details[0].assignmentValidityAonTo, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
        : '',
      value: request.requests_details[0].assignmentValidityAonTo
        ? moment(request.requests_details[0].assignmentValidityAonTo, 'YYYY-MM-DD').format(
            'DD/MM/YYYY'
          )
        : '',
    });
    _this[key].push({
      type: 'span',
      label: 'Subscriptor',
      eValue: parent.subscriptor.fullname,
      value: request.subscriptor.fullname,
    });
    _this[key].push({
      type: 'span',
      label: _this.dictionary['createdAt']
        ? _this.dictionary['createdAt'].label
        : 'Fecha de creaciòn',
      eValue: parent.createdAt
        ? moment(parent.createdAt).format('DD/MM/YYYY')
        : '',
      value: request.createdAt
        ? moment(request.createdAt).format('DD/MM/YYYY')
        : '',
    });
    _this[key].push({
      type: 'span',
      label: 'Numero de endoso',
      eValue: parent.requests_details[0].endorsement_quantity,
      value: request.requests_details[0].endorsement_quantity,
    });
    //ToDo show value if the form is not in endorsement state
    _this[key].push({
      name: 'special_aceptation',
      type: 'span',
      label: _this.dictionary['special_aceptation']
        ? _this.dictionary['special_aceptation'].label
        : 'Aceptación Especial',
      eValue:
        parent.requests_details[0].special_aceptation != undefined
          ? parent.requests_details[0].special_aceptation == 1
            ? 'Si'
            : 'No'
          : '',
      value: request.requests_details[0].special_aceptation ? 'Si' : 'No',
    });
    _this[key].push({
      name: 'assignment_percent_aon',
      type: 'span',
      label: 'Porcentaje de cesión a AON',
      eValue: parent.requests_details[0].assignment_percent_aon
        ? String(parent.requests_details[0].assignment_percent_aon)
        : '',
      value: String(request.requests_details[0].assignment_percent_aon),
    });

    if (_this.modifyType == 'complex') {
      //
      // Check endorsment with movement
      //
      _this[key].push({
        name: 'assignment_percent_aon',
        type: 'aon_percent',
        label: 'Porcentaje de cesión a AON (Endoso)',
        eValue: parent.requests_details[0].assignment_percent_aon,
        value: '',
        checkchanges: (newValue) => {
          if (_this.endosoCalculationType !== '1')
            _this.onInputFieldChange('assignment_percent_aon', false, newValue);
        },
      });

      _this[key].push({
        name: 'total_value_risks',
        type: 'input',
        label: _this.dictionary['total_value_risks']
          ? _this.dictionary['total_value_risks'].label
          : '',
        eValue: parent.requests_details[0].total_value_risks,
        value: '',
        checkchanges: async (newValue) => {
          if (_this.endosoCalculationType !== '1') {
            await _this.onInputFieldChange(
              'total_value_risks',
              false,
              +parent.requests_details[0].total_value_risks - +newValue
            );
          } else {
            _this.onInputFieldChange('total_value_risks', false, newValue);
          }
        },
        showFormattedToMoney: false,
        inputFormattedToMoney: false,
      });
      _this[key].push({
        name: 'total_sum_secured',
        type: 'input',
        label: _this.dictionary['total_sum_secured']
          ? _this.dictionary['total_sum_secured'].label
          : 'Suma asegurada total por la cedente',
        eValue: parent.requests_details[0].total_sum_secured,
        value: '',
        checkchanges: async (newValue) => {
          if (_this.endosoCalculationType === '1' && +newValue > 0) {
            const aon_sum = _this.rows
              .find((r) => r.name === 'aon_sum')
              .value.split(',')
              .join('');
            console.log('eee', newValue, aon_sum);
            const percetn_aon = (+aon_sum / +newValue) * 100;
            await _this.onInputFieldChange(
              'assignment_percent_aon',
              false,
              percetn_aon
            );
          }
          _this.onInputFieldChange('total_sum_secured', false, newValue);
        },
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'retained_sum',
        type: 'input',
        label: _this.dictionary['retained_sum']
          ? _this.dictionary['retained_sum'].label
          : 'Suma retenida + cesión a contratos',
        eValue: parent.requests_details[0].retained_sum,
        value: '',
        checkchanges: (newValue) =>
          _this.onInputFieldChange('retained_sum', false, newValue),
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'facultative_sum',
        type: 'input',
        label: _this.dictionary['facultative_sum']
          ? _this.dictionary['facultative_sum'].label
          : 'Suma cedida a facultativos',
        eValue: parent.requests_details[0].facultative_sum,
        value: '',
        checkchanges: (newValue) =>
          _this.onInputFieldChange('facultative_sum', false, newValue),
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'aon_sum',
        type: 'input',
        label: this.dictionary['aon_sum']
          ? this.dictionary['aon_sum'].label
          : 'Suma cedida a AON',
        eValue: parent.requests_details[0].aon_sum,
        value: '',
        checkchanges: async (newValue) => {
          const total_sum_secured = _this.rows
            .find((r) => r.name === 'total_sum_secured')
            .value.split(',')
            .join('');

          console.log('aaa', +newValue, +total_sum_secured);
          if (_this.endosoCalculationType === '1') {
            const percent_aon = (+newValue / +total_sum_secured) * 100;
            console.log(percent_aon);
            if (!isNaN(percent_aon)) {
              await _this.onInputFieldChange(
                'assignment_percent_aon',
                false,
                percent_aon
              );
            }
          }
          _this.onInputFieldChange('aon_sum', false, newValue);
        },
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'aon_sum_extra',
        type: 'input',
        label: _this.dictionary['aon_sum_extra']
          ? _this.dictionary['aon_sum_extra'].label
          : 'Suma cedida a AON Extra',
        eValue: parent.requests_details[0].aon_sum_extra,
        value: '',
        checkchanges: (newValue) =>
          _this.onInputFieldChange('aon_sum_extra', false, newValue),
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });

      _this[key].push({
        name: 'original_tax',
        type: 'span',
        label: _this.dictionary['original_tax']
          ? _this.dictionary['original_tax'].label
          : 'Tasa original',
        eValue: parent.requests_details[0].original_tax,
        value: '',
        checkchanges: (newValue) =>
          _this.onInputFieldChange('original_tax', true, newValue),
        showFormattedToMoney: false,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'original_gross_bonus',
        type: 'input',
        label: _this.dictionary['original_gross_bonus']
          ? _this.dictionary['original_gross_bonus'].label
          : 'Prima Bruta Del Endoso',
        eValue: parent.requests_details[0].original_gross_bonus,
        value: '',
        checkchanges: (newValue) =>
          _this.onInputFieldChange('original_gross_bonus', false, newValue),
        showFormattedToMoney: true,
        inputFormattedToMoney: true,
      });
      _this[key].push({
        name: 'original_gross_aon',
        type: 'span',
        label: _this.dictionary['original_gross_aon']
          ? _this.dictionary['original_gross_aon'].label
          : 'Prima Bruta cedida a AON',
        eValue: parent.requests_details[0].original_gross_aon,
        value: '',
      });
      return;
    } else {
      /*Normal view and anulation view*/
      for (let i in keys) {
        let index = keys[i];
        if (
          [
            'id',
            'deletedAt',
            'requestId',
            'countryId',
            'validity_from',
            'validity_to',
            'assignmentValidityAonFrom',
            'assignmentValidityAonTo',
            'assignment_percent_aon',
          ].indexOf(index) >= 0 ||
          !request.requests_details[0][index]
        )
          continue;

        let obj: any = {
          name: index,
          type: 'span',
          label: this.dictionary[index]
            ? this.dictionary[index].label
            : 'Campo',
          eValue: parent.requests_details[0][index],
          value: request.requests_details[0][index],
          inputFormattedToMoney: false,
          showFormattedToMoney: false,
        };

        if (
          [
            'coinsurance_participation',
            'excluded_from_contract',
            'special_aceptation',
          ].indexOf(index) >= 0
        ) {
          obj.eValue =
            obj.eValue !== undefined ? (obj.eValue ? 'Si' : 'No') : '';
          obj.value = obj.value ? 'Si' : 'No';
          this[key].push(obj);
          continue;
        }

        if (
          index === 'taxation' &&
          request.company &&
          request.company.country.id === 1
        )
          continue;

        if (
          [
            'assignment_percent_aon',
            'aon_sum',
            'aon_sum_extra',
            'facultative_sum',
            'original_gross_aon',
            'original_gross_bonus',
            'original_tax',
            'retained_sum',
            'total_sum_secured',
            'total_value_risks',
            'netpayment',
            'commission',
            'taxation',
          ].indexOf(index) >= 0
        ) {
          obj.showFormattedToMoney = index !== 'original_tax';
          if (index === 'original_tax') {
            obj.value = obj.value;
            obj.eValue = obj.eValue;
          }
          this[key].push(obj);
        }
      }
    }
  }

  isEndoso() {
    return this.request.modifyType > 0;
  }

  async addNote() {
    if (this.comment !== '') {
      try {
        const response: any = await (this.$root as any)._post(
          `requests/addnote/${this.$route.params.id}`,
          {
            note: this.comment,
          }
        );
        this.comment = '';
        await this.loadRequest();
        (this.$root as any).notify('Se agrego el comentario con éxito.');
      } catch (e) {
        (this.$root as any).notify('No se pudo agregar el comentario.', 'warn');
      }
    } else {
      (this.$root as any).notify('Campo de observaciones vacío', 'warn');
    }
  }

  async loadRequest() {
    const user: any = await (this.$root as any)._post(
      `subscriptors/one/${this.$store.state.user.id}`,
      {
        models: 'companies',
      }
    );
    let company: any = null;
    if (this.$store.state.companyId) {
      user.data[0].companies.forEach((c) => {
        if (c.id == this.$store.state.companyId) {
          company = c;
        }
      });
    } else {
      company = user.data[0].companies[0];
    }

    const request: any = await (this.$root as any)._post(
      `requests/one/${this.$route.params.id}`,
      {
        models: 'companies,branches,control_zones,subscriptors,currencies',
      }
    );

    if (company.id !== request.data[0].company.id) {
      return false;
    }

    this.request = request.data[0];
    this.canCreateEndorsements =
      this.request.child_requests.length === 0 &&
      this.request.status < 2 &&
      this.request.modifyType < 3;

    if (this.isEndoso()) {
      this.title = `Procesar solicitud ${this.request.code}`;
    } else {
      this.title = 'Detalle de solicitud';
    }

    return true;
  }

  async loadStatuses() {
    const response: any = await (this.$root as any)._get('requests/status');
    this.statuses = response;
  }

  async loadDictionary() {
    const response: any = await (this.$root as any)._get('requests/dictionary');
    this.dictionary = response;
  }

  async loadControlZones() {
    const user: any = await (this.$root as any)._post(
      `subscriptors/one/${this.$store.state.user.id}`,
      {
        models: 'companies',
      }
    );
    const company: any = user.data[0].companies[0];
    const response: any = await (this.$root as any)._post('controlzones/all', {
      countryId: company.countryId,
    });
    (this as any).controlZones = response.data;
  }

  async approveRequest() {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/${this.$route.params.id}/changestatus`,
        {
          status: this.statuses.indexOf('Procesada'),
        }
      );
      this.request.status = this.statuses.indexOf('Procesada');
      (this.$refs.modal1 as any).hide();
      this.statusText = `Solicitud de capacidad adicional procesada`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify('No se pudo procesar la solicitud.', 'error');
    }
  }

  async rejectRequest() {
    try {
      const response: any = await (this.$root as any)._post(
        `requests/${this.$route.params.id}/changestatus`,
        {
          status: this.statuses.indexOf('No Procesada'),
        }
      );
      this.request.status = this.statuses.indexOf('No Procesada');
      (this.$refs.modal2 as any).hide();
      this.statusText = `Se cambio el estado de la solicitud de capacidad adicional a No Procesada`;
      (this.$refs.modal3 as any).show();
    } catch (e) {
      (this.$root as any).notify('Error al cambiar el estado de la solicitud a No Procesada.', 'error');
    }
  }

  async confirmRequest() {
    let _this = this;
    _this.isValidForm = true;
    let fieldsToValidate = [
      'aon_sum',
      'aon_sum_extra',
      'facultative_sum',
      'original_gross_aon',
      'original_gross_bonus',
      'original_tax',
      'retained_sum',
      'total_sum_secured',
      'total_value_risks',
      'assignmentValidityAonFrom',
    ];
    _this.rows.forEach((row) => {
      if (fieldsToValidate.indexOf(row.name) !== -1)
        if (row.value === '') _this.isValidForm = false;
    });

    if (!_this.isValidForm) {
      (_this.$root as any).notify(
        'Por favor llenar los campos vacios',
        'error'
      );
      return;
    }

    let newRequest = _this.request;
    let newRequestDetails = { ..._this.request.requests_details[0] };
    newRequest.requestId = newRequest.id;
    delete newRequest.id;
    delete newRequest.status;
    delete newRequest.trimester;

    newRequest.validity_from = moment(
      newRequest.validity_from,
      'YYYY-MM-DD'
    ).format('DD/MM/YYYY');
    newRequest.validity_to = moment(
      newRequest.validity_to,
      'YYYY-MM-DD'
    ).format('DD/MM/YYYY');

    if (_this.modifyType === 'simple' || _this.modifyType === 'complex') {
      _this.rows.forEach((row) => {
        if (row.type === 'dropdown' && row.name === 'controlZoneId') {
          newRequest[row.name] = row.value;
        } else if (
          row.name === 'assignmentValidityAonTo' ||
          row.name === 'assignmentValidityAonFrom'
        ) {
          newRequestDetails[row.name] = moment(row.value, 'DD/MM/YYYY').format(
            'YYYY-MM-DD'
          );
        } else if (
          row.type === 'datepicker' ||
          row.type === 'checkbox' ||
          row.name === 'policy_number'
        ) {
          newRequestDetails[row.name] = row.value;
        } else if (row.type === 'input' || row.name === 'original_gross_aon') {
          newRequestDetails[row.name] = parseFloat(
            String(row.value).replace(/,/g, '')
          );
        }
      });
    }

    newRequest.countryId = newRequest.control_zone
      ? newRequest.control_zone.countryId
      : newRequest.company.countryId;
    newRequest.controlZoneId =
      newRequest.controlZoneId == 'NULL' ? null : newRequest.controlZoneId;
    newRequest.modifyType =
      _this.modifyType === 'simple'
        ? 1
        : _this.modifyType === 'complex'
        ? 2
        : _this.modifyType === 'anulation'
        ? 3
        : 0;
    newRequest.subscriptorId = _this.$store.state.user.id;

    let response: any = '';

    newRequestDetails.notes = this.comment;

    response = await (_this.$root as any)._post('requests/', {
      ...newRequest,
      ...newRequestDetails,
    });

    if (!response.id) {
      (_this.$root as any).notify(response.error, 'error');
      return;
    } else {
      let type = '';
      if (_this.modifyType === 'simple') {
        type = 'Endoso sin movimientos';
      } else if (_this.modifyType === 'complex') {
        type = 'Endoso con movimientos';
      } else {
        type = 'Anulación';
      }

      (_this.$root as any).notify(`${type} enviada con éxito!`, 'success');
      _this.$router.push(`/requests/${response.id}/details`);
    }
  }
}
